<template>
  <widget-step-page
    :btn-next-disabled="isBtnNextDisabled"
    :btn-prev-disabled="false"
    :on-btn-prev-clicked="onBtnPrevClicked"
    :on-btn-next-clicked="onBtnNextClicked"
  >
    <template #content>
      <div class="d-flex flex-column px-4 pb-4 pt-8">
        <span class="pb-7">Для завершения записи к врачу необходимо подтвердить номер телефона.</span>
        <span class="pb-7">На номер <b style="font-weight: 600">{{ patientPhoneFormatted }}</b> была отправлена SMS с кодом подтверждения.</span>
        <span class="pb-7">Введите его в поле ниже, пожалуйста:</span>

        <div class="d-flex flex-column align-center">
          <x-text-field
            v-model="localUserSmsCode"
            autocomplete="one-time-code"
            placeholder="Введите код"
            :clearable="false"
            v-maska
            :data-maska="'#'.repeat(SMS_CODE__LENGTH)"
            style="width: 350px"
          />
          <span
            v-show="smsDevCode"
            style="font-size: 16px"
          >
            {{ `DevCode: ${smsDevCode}` }}
          </span>
        </div>

        <div class="d-flex justify-center text-center pt-8">
          <div
            v-if="smsErrorCode === 'sms.over'"
            class="d-flex flex-column error--text"
            style="font-size: 16px"
          >
            <span>К сожалению, был достигнут лимит отправки SMS на указанный номер.</span>
            <span>Пожалуйста, повторите действие через 24 часа или введите другой номер телефона</span>
          </div>
          <template v-else>
            <x-count-down-label
              v-show="!showResendBtn"
              :expire-timestamp="smsExpireTimestamp"
              @timer-expired="showResendBtn = true"
            />
            <x-btn
              v-show="showResendBtn"
              :ripple="false"
              color="#F39F18"
              width="148"
              height="39"
              class="x-btn__warning"
              @click="onResendOneTimeCode"
            >
              Запросить код
            </x-btn>
          </template>
        </div>
      </div>
    </template>
  </widget-step-page>
</template>

<script>
import {
  SMS_CODE__LENGTH, WIDGET_STEP__FINAL,
  WIDGET_STEP__PATIENT_DATA, WIDGET_STEP__SELECT_SERVICE
} from "@/plugins/consts"
import WidgetStepPage from "@/components/page-template/WidgetStepPage"
import XTextField from "@/components/x-env/text-field/XTextField"
import {isNullOrUndefined} from "@/plugins/object-helpers"
import XCountDownLabel from "@/components/x-env/label/XCountDownLabel"
import XBtn from "@/components/x-env/btn/XBtn"
import {mapGetters} from "vuex"

export default {
  components: {
    XBtn,
    XCountDownLabel,
    WidgetStepPage,
    XTextField,
  },
  data() {
    return {
      SMS_CODE__LENGTH,

      localUserSmsCode: null,
      showResendBtn: false,
    }
  },
  computed: {
    ...mapGetters([
      'patientPhone',
      'patientPhoneFormatted',
      'smsId',
      'smsDevCode',
      'smsErrorCode',
      'smsExpireTimestamp'
    ]),
    isBtnNextDisabled() {
      return isNullOrUndefined(this.localUserSmsCode) || this.localUserSmsCode.length !== SMS_CODE__LENGTH
    },
  },
  async mounted() {
    if (this.smsId === null) {
      await this.sendSmsCode()
    }
  },
  methods: {
    onBtnPrevClicked() {
      this.$store.commit('setUserSmsCode', null)
      this.$emit('change-step', WIDGET_STEP__PATIENT_DATA)
    },

    async onBtnNextClicked() {
      if (this.isBtnNextDisabled) {
        return
      }

      this.$store.commit('setUserSmsCode', this.localUserSmsCode)
      await this.performBooking()
    },

    async onResendOneTimeCode() {
      await this.sendSmsCode()
      this.showResendBtn = false
    },

    /**
     * Отправка SMS-кода для подтверждения номера телефона
     */
    async sendSmsCode() {
      this.$eventBus.$emit('show-overlay', true)
      await this.$axios
        .post(`${this.$backendLink}/widget/send-sms`, this.patientPhone, {
          headers: {
            'Content-Type': 'text/plain'
          }
        })
        .then(response => {
          const data = response.data
          this.$store.commit('setSmsErrorCode', null)
          this.$store.commit('setSmsInfo', {
            smsId: data.smsId,
            smsCode: data.smsCode,
            secondsLeft: data.secondsLeft
          })
        })
        .catch(error => {
          this.$store.commit('setSmsErrorCode', error.response.data)
        })
        .finally(() => {
          this.$eventBus.$emit('show-overlay', false)
        })
    },

    /**
     * Создание бронирования
     */
    async performBooking() {
      this.$eventBus.$emit('show-overlay', true)
      await this.$axios
        .post(`${this.$backendLink}/widget/booking`, {
          smsId: this.smsId,
          smsCode: this.$store.getters.userSmsCode,
          firstName: this.$store.getters.patientForename,
          secondName: this.$store.getters.patientPatronymic,
          lastName: this.$store.getters.patientSurname,
          gender: this.$store.getters.patientGender,
          birthday: this.$store.getters.patientBirthdate,
          phone: this.$store.getters.patientPhone,
          doctorId: this.$store.getters.doctorId,
          filialId: this.$store.getters.filialId,
          serviceId: this.$store.getters.serviceId,
          scheduleId: this.$store.getters.scheduleId,
          filialName: this.$store.getters.filialName,
          serviceInfo: this.$store.getters.serviceInfo,
          doctorName: this.$store.getters.doctorName,
          specialityName: this.$store.getters.specialityFilterName,
          doctorNote: this.$store.getters.doctorNote,
          scheduleInfo: this.$store.getters.scheduleInfo,
        })
        .then(() => {
          this.$emit('change-step', WIDGET_STEP__FINAL)
        })
        .catch(async (error) => {
          this.$store.commit('setUserSmsCode', null)
          const errorCode = error.response.data
          if (['schedule.notFound', 'schedule.isBusy'].includes(errorCode)) {
            this.$root.$confirm('К сожалению, выбранные дата и время приёма уже заняты.\n\nПожалуйста, повторите выбор и завершите запись',
              {agreeText: 'ОК', cancelVisible: false})
            this.$store.commit('setScheduleId', null)
            this.$store.commit('setScheduleList', [])
            this.$emit('change-step', WIDGET_STEP__SELECT_SERVICE)
          } else if (errorCode === 'smscode.invalid') {
            this.$eventBus.$emit('show-error', 'SMS-код введён неверно')
          } else if (errorCode === 'sms.expired') {
            this.$eventBus.$emit('show-error', 'Срок действия SMS-кода истёк')
            await this.sendSmsCode()
          } else if (errorCode === 'sms.attempts.over') {
            this.$eventBus.$emit('show-error', 'Закончились попытки ввода SMS-кода')
            await this.sendSmsCode()
          } else if (error.response.status >= 400 && error.response.status <= 499) {
            this.$eventBus.$emit('show-error', "Произошла ошибка, мы её уже исправляем.\nПопробуйте, пожалуйста, позже")
          } else if (error.response.status >= 500 && error.response.status <= 599) {
            this.$eventBus.$emit('show-error', "На стороне сервера произошла ошибка, мы её уже исправляем.\nПопробуйте, пожалуйста, позже")
          }
        })
        .finally(() => {
          this.$eventBus.$emit('show-overlay', false)
        })
    }
  }
}
</script>

<style scoped>
</style>